module.exports = __webpack_public_path__ + "img/1503064926.dd46b716.jpg";